import { FC } from 'react'
import { matchPath, useBlocker } from 'react-router-dom'
import { recruiterRouteConfig } from 'recruiter/routes'
import UnsavedChangesModal, {
    UnsavedChangesModalProps,
} from './UnsavedChangesModal'

interface Props extends UnsavedChangesModalProps {
    unsavedChangesExist: boolean
    message?: string
    onClose?: () => void
}

const UnsavedChangesModalNavBlocker: FC<Props> = ({
    unsavedChangesExist,
    message = 'You have unfinished sections. If you leave now, your progress will be lost.',
    ...props
}) => {
    const exemptPaths = [
        `${recruiterRouteConfig.candidates.path}/:candidateId/career`,
        `${recruiterRouteConfig.candidates.path}/:candidateId/overview`,
        `${recruiterRouteConfig.candidates.path}/:candidateId/background`,
        `${recruiterRouteConfig.candidates.path}/:candidateId/communications`,
        `${recruiterRouteConfig.candidates.path}/:candidateId/documents`,
    ]

    const isExemptPath = (pathname: string) => {
        return exemptPaths.some((path) => matchPath(path, pathname))
    }

    let blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            unsavedChangesExist &&
            currentLocation.pathname !== nextLocation.pathname &&
            !isExemptPath(nextLocation.pathname)
    )

    const handleLeaveClick = () => {
        if (props.onLeaveClick) {
            props.onLeaveClick()
        }
        if (blocker.proceed) {
            blocker.proceed()
        }
    }

    const handleStayClick = () => {
        if (props.onStayClick) {
            props.onStayClick()
        }
        if (blocker.reset) {
            blocker.reset()
        }
    }

    return (
        <UnsavedChangesModal
            {...props}
            open={blocker.state === 'blocked'}
            onLeaveClick={handleLeaveClick}
            onStayClick={handleStayClick}
        />
    )
}

export default UnsavedChangesModalNavBlocker
